import React from "react";

export type MetricTone = "neutral" | "good" | "bad" | "warning";

const toneClasses: Record<MetricTone, string> = {
  neutral: "border-gray-200 bg-white",
  good: "border-green-200 bg-green-50",
  bad: "border-red-200 bg-red-50",
  warning: "border-yellow-200 bg-yellow-50",
};

const valueToneClasses: Record<MetricTone, string> = {
  neutral: "text-gray-900",
  good: "text-green-700",
  bad: "text-red-700",
  warning: "text-yellow-700",
};

interface MetricCardProps {
  label: string;
  value: React.ReactNode;
  unit?: string;
  tone?: MetricTone;
}

/** Small stat card for a single key numeric/engineering value (e.g. Max Error %FS). */
export const MetricCard: React.FC<MetricCardProps> = ({ label, value, unit, tone = "neutral" }) => (
  <div className={`rounded-lg border p-4 ${toneClasses[tone]}`}>
    <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">{label}</p>
    <p className={`mt-1 text-xl font-semibold ${valueToneClasses[tone]}`}>
      {value === null || value === undefined || value === "" ? (
        <span className="text-sm font-normal text-gray-400 italic">Not available</span>
      ) : (
        <>
          {value}
          {unit && <span className="ml-1 text-sm font-normal text-gray-500">{unit}</span>}
        </>
      )}
    </p>
  </div>
);
